
function bindSizeButtons() {
  document.querySelectorAll('.hover-sizes__btn').forEach(button => {
    if (button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        const drawerResponse = await fetch('/?section_id=cart-drawer');
        const drawerHTML = await drawerResponse.text();
        const newDrawer = new DOMParser().parseFromString(drawerHTML, 'text/html').querySelector('#cart-drawer');

        if (newDrawer) {
          document.querySelector('#cart-drawer')?.replaceWith(newDrawer);
          document.querySelector('[aria-controls="cart-drawer"]')?.click();
        }

      } catch (err) {
        console.error('Add to cart failed:', err);
      }
    });
  });
}

// Bind on load with delay
document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      bindSizeButtons();
    }, 50);
  });
});

// Rebind on DOM updates (for related products)
new MutationObserver(() => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      bindSizeButtons();
    }, 50);
  });
}).observe(document.body, {
  childList: true,
  subtree: true
});
